<template>
  <div class="section grid-view" style="padding: 10px 20px">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>

            <el-button
              no="new"
              :disabled="!isEdit || !canAdd"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="edit"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="450px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Partners.WarehouseType')">
            <el-select v-model="editDialog.form.warehouseType" no="warehouseType">
              <el-option :label="$t('Partners.ordinary')" :value="0" />
              <el-option :label="$t('Partners.supervise')" :value="1" />
              <el-option :label="$t('SeaExport.BackUpWarehouse')" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.WareHouseName')">
            <el-input v-model="editDialog.form.warehouseName" no="warehouseName" />
          </el-form-item>
          <el-form-item :label="$t('Payment.contactPerson')">
            <el-input v-model="editDialog.form.warehouseContact" no="warehouseContact" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="editDialog.form.warehouseContactTel" no="warehouseContactTel" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.WarehouseAddress')">
            <el-input v-model="editDialog.form.warehouseAddress" no="warehouseAddress" />
          </el-form-item>
          <el-form-item :label="$t('Partners.WarehouseMap')">
            <el-upload
              no="warehouseMap"
              action
              :auto-upload="false"
              accept="image/png, image/jpeg"
              list-type="picture"
              :file-list="editDialog.fileList"
              :limit="1"
              :on-change="toChooseFile"
              :on-remove="toRemoveFile"
            >
              <el-button no="mapFileName" type="primary">{{ $t('FileHistory.Upload') }}</el-button>
              <span style="color: #999999; font-size: 10px; padding-left: 3px;">{{ $t('CargoMsg.Cargo_WarehouseMapTip') }}</span>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultWarehouse" no="defaultWarehouse" @change="onDefaultChange">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.LoadingRemarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" type="textarea" :rows="9" />
          </el-form-item>
          <el-form-item :label="$t('Partners.warehousingRequirements')">
            <el-input v-model="editDialog.form.warehousingRequirements" no="warehousingRequirements" />
          </el-form-item>
          <el-form-item :label="$t('Partners.associatedRoute')">
            <cargo-advance-select
              no="associatedRoute"
              :select-type="selectTypeNames.basic_data_Region"
              :default-multiple-value="regionUuids"
              tag-value="uuid"
              multiple
              @parentCallBack="regionCallBack"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getWarehouseList } from '@/api/partner/warehouse'
import { cache } from '@/utils/cacheManager'
import { AutoIncrementNum } from '@/utils/commonUtil'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import { WareHouseRegion } from '@/class/model/sys/WareHouseRegion'

export default {
  name: 'WarehouseForm',
  components: { CargoAdvanceSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      openNewWareHouse: false,
      selectedRow: null,
      canAdd: true,
      company: {},
      filter: {
        companyUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: p => { this.selectedRow = p.data }
      },
      columnDefs: [
        {
          headerName: this.$t('Partners.WarehouseType'),
          field: 'warehouseType',
          width: 200,
          valueFormatter: params => {
            return ColumnUtils.warehouseTypeLabFun(params.value)
          }
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultWarehouse',
          width: 200,
          valueFormatter: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        }, {
          headerName: this.$t('SeaExport.WareHouseName'),
          field: 'warehouseName',
          width: 200
        }, {
          headerName: this.$t('Payment.contactPerson'),
          field: 'warehouseContact',
          width: 200
        }, {
          headerName: this.$t('SeaExport.Tel'),
          field: 'warehouseContactTel',
          width: 200
        }, {
          headerName: this.$t('SeaExport.WarehouseAddress'),
          field: 'warehouseAddress',
          width: 200
        }, {
          headerName: this.$t('Partners.WarehouseMap'),
          field: 'mapFile',
          width: 200,
          cellRenderer: params => {
            if (!params.value) {
              return ''
            }
            return `<img src="data:image/jpeg;base64,${params.value}" fit="fill" style="height:25px;" >`
          }
        }, {
          headerName: this.$t('SeaExport.LoadingRemarks'),
          field: 'remarks',
          width: 200,
          tooltip: (params) => {
            return params.value
          }
        }, {
          headerName: this.$t('Partners.warehousingRequirements'),
          field: 'warehousingRequirements',
          width: 200,
          tooltip: (params) => {
            return params.value
          }
        }, {
          headerName: this.$t('Partners.associatedRoute'),
          field: '',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.wareHouseRegionLabelFunc(params.data.warehouseRegions)
          }
        }
      ],
      rowData: [],
      editDialog: {
        visible: false,
        title: '',
        form: {},
        fileList: []
      },
      autoIncrementNum: new AutoIncrementNum(),
      selectTypeNames: TYPE_NAMES,
      regionUuids: []
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.openNewWareHouse = parseInt(cache.config.get('isOpenWarehouse')) > 0
        this.company = row
        this.filter.companyUuid = row.uuid
        this.toQuery()
        this.deletedWarehouseKeys = []
      }
    },
    async toQuery() {
      const filter = this.filter
      if (!this.company.warehouseDetail) {
        if (filter.companyUuid) {
          await getWarehouseList(filter).then(res => {
            res.data.list.forEach(item => {
              item.seq = this.autoIncrementNum.getNextNum()
            })
            this.company.warehouseDetail = res.data.list
          })
        } else {
          this.company.warehouseDetail = []
        }
      }
      this.rowData = this.company.warehouseDetail
      this.checkAddButton()
    },
    showEditDialog(isNew) {
      this.regionUuids = []
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          warehouseType: '',
          warehouseName: '',
          warehouseContact: '',
          warehouseContactTel: '',
          warehouseAddress: '',
          mapFileName: '',
          mapFile: '',
          defaultWarehouse: false,
          companyUuid: this.filter.companyUuid,
          remarks: '',
          warehousingRequirements: '',
          seq: this.autoIncrementNum.getNextNum(),
          warehouseRegions: []
        }
        this.editDialog.fileList = []
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.rowData[cell.rowIndex] : null
        const rows = row ? [row] : []
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        if (this.editDialog.form.warehouseRegions && this.editDialog.form.warehouseRegions.length > 0) {
          for (const item of this.editDialog.form.warehouseRegions) {
            this.regionUuids.push(item.regionUuid)
          }
        }
        this.editDialog.fileList = []
        if (rows[0] && rows[0].mapFileName && rows[0].mapFile) {
          this.editDialog.fileList = [{
            name: rows[0].mapFileName,
            url: 'data:image/jpeg;base64,' + rows[0].mapFile
          }]
        }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    toChooseFile(file) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file.raw) // 转base64
      fileReader.onload = (e) => {
        this.editDialog.form.mapFileName = file.name
        this.editDialog.form.mapFile = e.target.result.split('base64,')[1]
        this.fileList = [{
          name: this.editDialog.form.mapFileName,
          url: this.editDialog.form.mapFile
        }]
      }
    },
    toRemoveFile() {
      this.editDialog.form.mapFileName = ''
      this.editDialog.form.mapFile = ''
      this.editDialog.fileList = []
    },
    getSubmitData() {
      return {
        warehouseDetail: this.rowData,
        deletedWarehouseKeys: this.deletedWarehouseKeys
      }
    },
    saveSub() {
      const self = this
      const form = self.editDialog.form
      if (this.openNewWareHouse) {
        if (form.defaultWarehouse) {
          for (const row of this.rowData) {
            row.defaultWarehouse = false
          }
        }
      }
      const oldRow = this.rowData.find(p => p.seq === form.seq)
      if (oldRow) {
        Object.assign(oldRow, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
        this.checkAddButton()
      }
      self.editDialog.visible = false
    },
    remove() {
      const self = this
      const rows = this.selectedRow ? [this.selectedRow] : []
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === rows[0].seq)
        this.rowData.splice(index, 1)
        if (rows[0].uuid) {
          this.deletedWarehouseKeys.push(rows[0].uuid)
        }
        this.checkAddButton()
      }).catch(() => { })
    },
    checkAddButton() {
      this.canAdd = true
      if (this.isEdit) {
        if (!this.openNewWareHouse) {
          if (this.rowData.length >= 1) {
            this.canAdd = false
          } else {
            this.canAdd = true
          }
        }
      }
    },
    onDefaultChange() {
      if (!this.openNewWareHouse) return
      const form = this.editDialog.form
      if (form.defaultWarehouse) {
        const existItem = this.rowData.find(p => p.defaultWarehouse && p.uuid !== form.uuid)
        if (existItem) {
          this.$message.warning(this.$t('Partners.alreadyDefaultWarehouse'))
        }
      }
    },
    async regionCallBack(regions) {
      this.regionUuids = regions ? regions.uuid : []
      let warehouseRegions = this.editDialog.form.warehouseRegions
      if (regions && regions.uuid && regions.uuid.length > 0) {
        const warehouseUuid = this.editDialog.form.uuid
        if (warehouseRegions && warehouseRegions.length > 0) {
          for (const item of warehouseRegions) { // 先处理被删除的数据
            let isFind = false
            for (const key of regions.uuid) {
              if (item.regionUuid && item.regionUuid === key) {
                isFind = true
                break
              }
            }
            if (!isFind) {
              if (item.uuid) { // 数据库真实存在的
                item.deleted = true
              } else { // 新增的，然后在删除，此时直接移除掉即可
                const index = warehouseRegions.findIndex(p => p === item)
                if (index > -1) {
                  warehouseRegions.splice(index, 1)
                }
              }
            }
          }
          // 判断新增的
          for (const key of regions.uuid) {
            let isFind = false
            for (const item of warehouseRegions) {
              if (item.regionUuid && item.regionUuid === key) {
                isFind = true
                break
              }
            }
            if (!isFind) {
              const region = await this.getRegion(key)
              if (region) {
                const warehouseRegion = new WareHouseRegion().fillDefaultValue().getData()
                warehouseRegion.wareHouseUuid = warehouseUuid
                warehouseRegion.regionUuid = key
                warehouseRegion.regionName = region.name
                warehouseRegion.regionEnglishName = region.nameEnglish
                warehouseRegions.push(warehouseRegion)
              }
            }
          }
        } else {
          warehouseRegions = []
          for (const key of regions.uuid) {
            const region = await this.getRegion(key)
            if (region) {
              const warehouseRegion = new WareHouseRegion().fillDefaultValue().getData()
              warehouseRegion.wareHouseUuid = warehouseUuid
              warehouseRegion.regionUuid = key
              warehouseRegion.regionName = region.name
              warehouseRegion.regionEnglishName = region.nameEnglish
              warehouseRegions.push(warehouseRegion)
            }
          }
        }
      } else { // 全部删除
        if (warehouseRegions && warehouseRegions.length > 0) {
          for (const item of warehouseRegions) {
            if (item.uuid) {
              item.deleted = true
            } else {
              const index = warehouseRegions.findIndex(p => p === item)
              if (index > -1) {
                warehouseRegions.splice(index, 1)
              }
            }
          }
        }
      }
      this.editDialog.form.warehouseRegions = warehouseRegions
    },
    async getRegion(key) {
      let region = null
      const regions = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
      if (regions && regions.length > 0 && key) {
        region = regions.find(p => p.uuid === key)
      }
      return region
    }
  }
}
</script>

<style>
</style>
